<template>
  <div v-if="session">
    <div>
      <v-alert v-model="alertBerhasil" type="success" dense dismissible>
        {{ alertMassage }}
      </v-alert>
      <v-alert v-model="alertGagal" type="error" dense dismissible>
        {{ alertMassage }}
      </v-alert>
    </div>

    <div>
      <v-data-table
        :headers="headers"
        :items="rwpendidikans"
        :items-per-page="-1"
        :mobile-breakpoint="0"
        :loading="ldata"
        hide-default-footer
        style="text-overflow: ellipsis; white-space: nowrap"
      >
        <template v-slot:top>
          <rwpendidikanModalEdit />
          <rwpendidikanModalHapus />
        </template>
        <template v-slot:[`item.namasekolah`]="{ item }">
          <div class="py-1">
            {{ item.namaSekolah }} <br />
            {{ item.lokasiSekolah }} <br />
            {{ item.tahunLulus }}
          </div>
        </template>
        <template v-slot:[`item.namakepsek`]="{ item }">
          <div class="py-1">
            {{ item.namaKepalaSekolah }} <br />
            {{ item.nomorIjasah }} <br />
            {{ item.tglLulus }}
          </div>
        </template>
        <template
          v-slot:[`item.actions`]="{ item }"
          v-if="
            session.authorities.some((item) => item === 'CRUD_ADMINISTRATOR')
          "
        >
          <v-icon small class="mr-1" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import Auth from "@/helper/auth.js";

import rwpendidikanModalEdit from "@/components/asn/profil/rwpendidikan/ModalEdit";
import rwpendidikanModalHapus from "@/components/asn/profil/rwpendidikan/ModalHapus";

import modal_editState from "@/store/asn/rwpendidikan/modal_edit";
import modal_hapusState from "@/store/asn/rwpendidikan/modal_hapus";
import refreshView from "@/store/asn/rwpendidikan/viewRwpendidikan";

export default {
  name: "rwpendidikan",

  components: {
    rwpendidikanModalEdit,
    rwpendidikanModalHapus,
  },

  computed: {
    refresh: {
      get() {
        return refreshView.state.Refresh;
      },
    },

    alertMassage: {
      get() {
        return refreshView.state.alertMassage;
      },
    },

    success: {
      get() {
        return refreshView.state.success;
      },

      set(value) {
        refreshView.commit("alert", value);
      },
    },

    alertBerhasil: {
      get() {
        return refreshView.state.alertBerhasil;
      },

      set(value) {
        refreshView.commit("berhasilAlert", value);
      },
    },

    alertGagal: {
      get() {
        return refreshView.state.alertGagal;
      },

      set(value) {
        refreshView.commit("gagalAlert", value);
      },
    },

    headers() {
      const headers = [
        {
          text: "Tingkat Pendidikan",
          align: "start",
          value: "pendidikan.nama",
        },
        {
          text: "Nama Sekolah / Perguruan Tinggi Tempat dan Tahun Lulus",
          value: "namasekolah",
        },
        { text: "Nama Kepsek Nomor dan Tanggal Ijazah", value: "namakepsek" },
      ];

      if (
        this.session.authorities.some((item) => item === "CRUD_ADMINISTRATOR")
      ) {
        headers.push({
          // actions header definition

          text: "Actions",
          value: "actions",
          sortable: false,
          align: "center",
          width: "80px",
        });
      }

      return headers;
    },
  },

  watch: {
    refresh() {
      this.getData();
      setTimeout(() => {
        this.alertGagal = false;
        this.alertBerhasil = false;
      }, 5000);
    },
  },

  data: () => ({
    token: Cookie.get("token"),
    session: "",
    get_nip: "",

    ldata: true,

    rwpendidikans: [],
    rwpendidikan: {},

    //Kebutuhan Edit
    editedIndex: -1,
    hapusIndex: -1,
  }),

  async mounted() {
    this.session = JSON.parse(Cookie.dec(Cookie.get("myCookie")));
    this.get_nip = this.$route.params.id;
    this.getData();
  },

  methods: {
    getData() {
      this.ldata = true;
      const url = process.env.VUE_APP_ASN + "pendidikan/nip/" + this.get_nip;

      this.http
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.ldata = false;
          refreshView.commit("refreshData", false);
          this.rwpendidikans = response.data.mapData.RwPendidikan;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Auth.logout(this.token);
          } else if (error.response) {
            console.log(error.response.status);
          } else {
            console.log("Error", error.message);
          }
        });
    },

    editItem(item) {
      this.editedIndex = this.rwpendidikans.indexOf(item);
      this.rwpendidikan = Object.assign({}, item);
      modal_editState.commit("toggleModal", true);
      modal_editState.commit("editModal", Object.assign({}, item));
    },

    deleteItem(item) {
      this.hapusIndex = this.rwpendidikans.indexOf(item);
      this.rwpendidikan = Object.assign({}, item);
      modal_hapusState.commit("toggleModal", true);
      modal_hapusState.commit("hapusModal", Object.assign({}, item));
    },
  },
};
</script>
